import classes from './ViewContact.module.sass'
import view from '../../../assets/images/icons/view.svg'
import contact from '../../../assets/images/icons/contact.svg'
import heart from '../../../assets/images/icons/heart.svg'
import { useViewContact } from './hooks/useViewContact'
import { ViewItem } from '../../types/interfaces'

type Props = {
  visible: boolean
  viewData?: ViewItem[]
  contactData?: ViewItem[]
  selectedData?: ViewItem[]
}

export const ViewContact = ({
  viewData = [],
  contactData = [],
  selectedData = [],
  visible,
}: Props) => {
  const { calculate } = useViewContact()
  if (visible)
    return (
      <div className={classes.Container}>
        <img src={view} className={classes.Icon} alt="Просмотры" />
        <div>({calculate(viewData).today}) </div> {calculate(viewData).total}
        <img src={contact} alt="Контакты" className={classes.Icon} />
        <div>({calculate(contactData).today}) </div>
        {calculate(contactData).total}
        <img src={heart} alt="В избранном" className={classes.Icon} />
        <div>({calculate(selectedData).today}) </div>
        {calculate(selectedData).total}
      </div>
    )
}
